import React from 'react'

export default () => (
  <div>404 - We couldn't find the page you're looking for!</div>
)
